import React from 'react';
import cn from 'classnames';
import * as Fi from 'react-icons/fi';
import { Select } from 'ui/components';

import _ from 'underscore';

const posSaldoOptions = [
  { value: 'credit', label: 'Credit' },
  { value: 'debit', label: 'Debit' },
];

const posReportOptions = [
  { value: 'N', label: 'N' },
  { value: 'L/R', label: 'L/R' },
];

const initialState = {
  pos_saldo: null,
  pos_report: null,
};

const Filter = ({ show, onClose, CoaTable, setCount }) => {
  const [{ pos_saldo, pos_report }, setState] = React.useState(initialState);

  const handleFilter = async (e) => {
    if (CoaTable?.State?.filter) {
      let x = [];
      Object.keys(CoaTable?.State?.filter).forEach((k) => {
        if (
          CoaTable?.State?.filter[k] &&
          k !== 'start_at'
        ) {
          x.push(k);
        }
      });
      setCount(x);
    }
  };

  const $filterPosSaldo = (e) => {
    setState((prevState) => ({
      ...prevState,
      pos_saldo: e,
    }));

    CoaTable?.filter('pos_saldo', e?.value);
    handleFilter();
  };

  const $filterPosReport = (e) => {
    setState((prevState) => ({
      ...prevState,
      pos_report: e,
    }));

    CoaTable?.filter('pos_report', e?.value);
    handleFilter();
  };

  React.useEffect(() => {
    handleFilter();

    let ops = null
    let opr = null
    _.each(posSaldoOptions, (i) => {
      if (i?.value === CoaTable?.State?.filter?.pos_saldo) {
        ops = i
      }
    })

    _.each(posReportOptions, (i) => {
      if (i?.value === CoaTable?.State?.filter?.pos_report) {
        opr = i
      }
    })

    setState((prevState) => ({
      ...prevState,
      pos_saldo: ops,
      pos_report: opr,
      loading: false,
    }));
  }, []);

  return (
    <>
      <div
        className={cn(
          show
            ? 'col-md-3 d-none d-md-block py-3 px-3 m-0 border-start'
            : 'd-none'
        )}
      >
        <div className="mb-3 border-bottom">
          <div className="d-flex align-items-center justify-content-between">
            <div className="page-pretitle fs-7 text-secondary">Filter</div>
            <div className="mt-n1">
              <button className="btn btn-action-close " onClick={onClose}>
                <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Pos Saldo</div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={pos_saldo}
            initialValue={pos_saldo}
            options={posSaldoOptions}
            onChange={$filterPosSaldo}
          />
        </div>

        <div className="mb-3">
          <div className="page-pretitle text-secondary mb-2">Pos Report</div>
          <Select
            placeholder=""
            classNamePrefix="select"
            isClearable
            value={pos_report}
            initialValue={pos_report}
            options={posReportOptions}
            onChange={$filterPosReport}
          />
        </div>
      </div>

      <>
        <div
          className={cn('filter-overlay', show ? 'd-block d-md-none' : '')}
          onClick={onClose}
        />
        <div
          className={cn(
            'filter-modal d-block d-md-none py-3',
            show ? 'filter-show' : ''
          )}
        >
          <div className="mb-3 border-bottom">
            <div className="d-flex align-items-center justify-content-between">
              <div className="page-pretitle fs-7 text-secondary">Filter</div>
              <div className="mt-n1">
                <button className="btn btn-action-close " onClick={onClose}>
                  <Fi.FiX color="hsl(0deg 0% 81%)" size={18} />
                </button>
              </div>
            </div>
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Pos Saldo</div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={pos_saldo}
              initialValue={pos_saldo}
              options={posSaldoOptions}
              onChange={$filterPosSaldo}
            />
          </div>

          <div className="mb-3">
            <div className="page-pretitle text-secondary mb-2">Pos Report</div>
            <Select
              placeholder=""
              classNamePrefix="select"
              isClearable
              value={pos_report}
              initialValue={pos_report}
              options={posReportOptions}
              onChange={$filterPosReport}
            />
          </div>
        </div>
      </>
    </>
  );
};

export default Filter;
